module.exports = __webpack_public_path__ + "img/gallery-icon-03.9b067181.png";